import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Back from "shared/assets/images/svg/back_blue.svg";
import Info from "shared/assets/images/svg/info_gr.svg";
import Input from "shared/component/inputFields";
import { useCompanyInfo } from "customer/settings/companyInfo/company-info.service";
import FileUploader from "shared/component/file-upload/file-uploader";
import { serverImage } from "shared/helpers/client";
import { localize } from "shared/helpers/utils";
import { Spinner } from "react-bootstrap";

const CompanyInfo = () => {
  const{t}=useTranslation();
  const {
    companyInfoData,
    register,
    formState: { errors },
    handleSubmit,
    changeCompanyInfo,
    isLoading,
    currencies,
    countries,
    watch,
    setValue
  } = useCompanyInfo();

  const { countryId, currencyId } = watch();

  return (
    <form className="settingHome companyInfo" onSubmit={handleSubmit(changeCompanyInfo)}>
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>{t('company-info.info')}</h1>
          </div>
        </div>
        <hr className="hr" />
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.company-name')}  <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
              <Input
              type="text"
              require
              {...register("companyName")}
              error={errors.companyName?.message}
            />
              </div>
            </div>

            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.commercial')}  <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
              <Input
              type="text"
              require
              {...register("commercialRegister")}
              error={errors.commercialRegister?.message}
            />
              </div>
            </div>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.vat-number')} <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
              <Input
              require
              type="text"
              {...register("vatNumber")}
              error={errors.vatNumber?.message}
            />
              </div>
            </div>


            <h2 className="box-title">{t('company-info.location')}</h2>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.country')} <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
              <Input
              type="select"
              require
              value={countryId}
              error={errors.countryId?.message}
              {...register("countryId")}
              options={countries}
              getOptionLabel={(z) => localize(z.name)}
            />
              </div>
            </div>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.currency')} <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
              <Input
              type="select"
              require
              value={currencyId}
              error={errors.currencyId?.message}
              {...register("currencyId")}
              options={currencies}
              getOptionLabel={(z) => localize(z.name)}
            />
              </div>
            </div>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.city')}:
              </label>
              <div className="col-lg-8">
              <Input
              type="text"
              require
              {...register("cityName")}
              error={errors.cityId?.message}
            />
              </div>
            </div>
          

            <h2 className="box-title">{t('company-info.address')}</h2>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.street')}:
              </label>
              <div className="col-lg-8">
              <Input type="text" {...register("streetName")} />
              </div>
            </div>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.building')}
              </label>
              <div className="col-lg-8">
                <div className="row">
                <div className="col-md-6">
                <Input type="text"  {...register("buildingNumber")} />
              </div>
              <div className="col-md-6">
                <Input type="text"  {...register("apartmentNumber")} />
              </div>
                </div>
              </div>
            </div>

            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('company-info.postal')}
              </label>
              <div className="col-lg-8">
                <div className="row">
                <div className="col-md-6">
                <Input type="text"  {...register("postalCode")} />
              </div>
              <div className="col-md-6">
                <Input type="text"  {...register("extensionNumber")} />
              </div>
                </div>
              </div>
            </div>


          </div>
          <div className="col-lg-6 col-md-6">
            <div className="row">
              <div className="col-lg-6 ">
                <span className="imgTitle">{t('company-info.company-logo')}</span>
                <FileUploader
                  label={t('company-info.click-here')}
                  name="companyLogo"
                  onFileSubmit={(file) => setValue("companyLogo", file)}
                  initialImage={companyInfoData?.companyLogo}
                />
              </div>
            </div>

            {companyInfoData?.isPendingExist ? (
              <div className="hint">
                <img src={Info} alt="Info" />
                <p>{t('company-info.data-review-msg')}</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {/* <div className="action">
        <div className="container">
          <button
            type="submit"
            className="btn-blue"
            disabled={companyInfoData?.isPendingExist || isLoading}
          >
            <Spinner animation="border" size="sm" hidden={!isLoading} /> Request Data Change
          </button>
        </div>
      </div> */}
    </form>
  );
};

export default CompanyInfo;
